import i18n from 'i18next';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setWeightUnitOfMeasurement } from '../../../redux/common/CommonActions';
import { getWeightUomEffect } from '../../../redux/shipment/ShipmentEffects';
import { routeFileSelector } from '../../../utilz/i18n';
import FormSelectBox from '../Inputs/FormSelectBox';

const WeightUomSelector = ({
  placeholder = i18n.t('translation:default.fields.weightMeasurement.placeholder'),
  label = i18n.t('translation:default.fields.weightMeasurement.label'),
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  tooltip,
  isDefault = false,
  tabIndex,
  disableValidation = false,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const weightUomList = useSelector((state) => state.common.weightUomList, shallowEqual);

  useEffect(() => {
    if (weightUomList.length > 0) {
      setOptions(weightUomList);
    } else {
      getStatusList();
    }
  }, [editMode]);

  const getStatusList = async () => {
    try {
      setLoading(true);
      const { data } = await getWeightUomEffect();
      const options = data.map((row) => ({
        label: row.text,
        value: row.value,
      }));
      setOptions(options);
      dispatch(setWeightUnitOfMeasurement(options));
      setLoading(false);
    } catch {
      setOptions([]);
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      loading={loading}
      options={
        isDefault === true ? [{ label: t('translation:default.buttons.select'), value: '' }, ...options] : options
      }
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      tooltip={tooltip}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      dataTestId="product-details-weight-uom"
    />
  );
};

export default WeightUomSelector;
